import axios from 'axios'
import Vue from 'vue'

import VueRouter from 'vue-router'
// import Index from './views/Index.vue'

axios.interceptors.response.use(
  (res) => { return res; },
  (err) => {
    if (err.response.status == 401) {
      window.location = '/login';
    } else {
      return Promise.reject(err);
    }
  }
)

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('./views/Index.vue'),
    beforeEnter: (to, from, next) => {
      next()
    }
  },
  {
    path: '/login',
    component: () => import('./views/Login.vue')
  },
  {
    path: '/dashboard/:channelId/:workspaceId',
    component: () => import('./views/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      next()
    }
  },
  {
    path: '/fixed-journals/:channelId',
    component: () => import('./views/FixedJournalPanel.vue')
  },
  {
    path: '/console',
    component: () => import('./views/Console.vue')
  },
  {
    path: '/debug',
    component: () => import('./views/Debug.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
